export class ErrorEntity {
    isValid;
    errorMessage;
  
    constructor(isValid = true, errorMessage = "") {
      this.isValid = isValid;
      this.errorMessage = errorMessage;
    }
  }
  